import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useContext } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Screens from '../..';
import MessageInterface from '../../../api/MessageInterface';
import ShopInterface from '../../../api/ShopInterface';
import InboxMessagesProvider from '../../../components/InboxMessagesProvider';
import { PLATFORM } from '../../../constants';
import { purchaseActionTriggers } from '../../../constants/userActions';
import NotificationContext from '../../../context/NotificationContext';
import logger from '../../../lib/analytics/logger';
import { setPurchaseType } from '../../../state/actions/prePurchase';
import { fetchGameRooms } from '../../../state/query/games/utils';
import utils from '../../../utils';
import DynamicAction from '../../../utils/DynamicAction';
import audio from '../../../utils/audio';
import cdnPath from '../../../utils/cdnPath';
import { TEXT_KEY, getText } from '../../../utils/localization';
import { format, messageTypes, rewardTypes } from '../../../utils/messageTypes';
import QueryParamProxy from '../../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseTypes } from '../../../utils/routeParamConstants';
import transformObjectArrayResponse from '../../../utils/transformObjectArrayResponse';

var useMessageItem = function useMessageItem(_ref) {
  var message = _ref.message,
      navigation = _ref.navigation,
      buyHandler = _ref.buyHandler,
      renderMessage = _ref.renderMessage;
  var dispatch = useDispatch();
  var context = useContext(NotificationContext);

  var _useSelector = useSelector(function (state) {
    return {
      unlimitedVipAccess: state.consumables.unlimitedVipAccess,
      imagesCdnBaseUrl: state.app.assetsUrls.ImagesCdnBaseUrl
    };
  }, shallowEqual),
      unlimitedVipAccess = _useSelector.unlimitedVipAccess,
      imagesCdnBaseUrl = _useSelector.imagesCdnBaseUrl;

  var coin_amount = message.coin_amount,
      loyalty_amount = message.loyalty_amount,
      action = message.action,
      background = message.background,
      icon = message.icon,
      subject = message.subject;

  var getMessageType = function getMessageType() {
    if (action.includes('gameid:')) return renderMessage.GAME;
    if (action.includes('vippass:')) return renderMessage.VIP_PASS;
    if (action.includes('offer:')) return renderMessage.OFFER;
    if (action.includes('sneakPeek:')) return renderMessage.SNEAK_PEEK;
    if (loyalty_amount > 0) return renderMessage.LOYALTY;
    if (coin_amount > 0) return renderMessage.COINS;
    return renderMessage.PROMO;
  };

  var messageType = getMessageType();

  var getBackgroundImage = function getBackgroundImage() {
    if ([messageTypes.VIP_PASS, messageTypes.SNEAK_PEEK].includes(messageType.type)) return messageType.background;

    if (background) {
      var uri = "".concat(imagesCdnBaseUrl, "/inbox_messages/").concat(background);
      return utils.getPlatform() === PLATFORM.WEB ? uri : {
        uri: uri
      };
    }

    return messageType.background || '';
  };

  var getSubtitle = function getSubtitle() {
    switch (messageType.type) {
      case messageTypes.LOYALTY:
        return utils.truncateFormat(loyalty_amount);

      case messageTypes.COINS:
        return utils.truncateFormat(coin_amount);

      case messageTypes.SNEAK_PEEK:
        return subject;

      case messageTypes.VIP_PASS:
        var dynamicText = "";
        var totalSeconds = parseInt(message.action.split(':')[1]);
        var hours = Math.floor(totalSeconds / 3600);
        if (hours > 0) dynamicText += " ".concat(hours, " ").concat(getText(hours > 1 ? TEXT_KEY.HOURS : TEXT_KEY.HOUR));
        totalSeconds %= 3600;
        var minutes = Math.floor(totalSeconds / 60);
        if (minutes > 0) dynamicText += " ".concat(minutes, " ").concat(getText(TEXT_KEY.MINUTES));
        var seconds = totalSeconds % 60;
        if (seconds > 0) dynamicText += " ".concat(seconds, " ").concat(getText(TEXT_KEY.SECONDS));
        var vipPassSubtitle = "".concat(getText(TEXT_KEY.VIP_PASS_SUBTITLE_REDEEM)).concat(dynamicText).concat(getText(TEXT_KEY.VIP_PASS_SUBTITLE_EXCLUSIVE)).concat(getText(TEXT_KEY.VIP)).concat(getText(TEXT_KEY.VIP_PASS_SUBTITLE_ACCESS));
        return vipPassSubtitle;

      case messageTypes.OFFER:
        var subtitle = "".concat(getText(TEXT_KEY.OFFER_TYPE_SUBTITLE_GET)).concat(format(message.coins)).concat(getText(TEXT_KEY.OFFER_TYPE_SUBTITLE_COINS)).concat(getText(TEXT_KEY.CURRENCY_SIGN)).concat(message.price, "!");
        return subtitle;

      default:
        return getText(TEXT_KEY.FIND_OUT_MORE);
    }
  };

  var getIconImage = function getIconImage() {
    var _action$split$;

    switch (messageType.type) {
      case messageTypes.VIP_PASS:
        return messageType.icon;

      case messageTypes.SNEAK_PEEK:
        var gameListArray = action && (action === null || action === void 0 ? void 0 : (_action$split$ = action.split(':')[1]) === null || _action$split$ === void 0 ? void 0 : _action$split$.split(','));

        if (gameListArray.length === 1 && gameListArray[0]) {
          return utils.getPlatform() === PLATFORM.WEB ? "".concat(cdnPath.SLOT_ICON_WEB).concat(gameListArray[0], ".png") : {
            uri: "".concat(cdnPath.SLOT_ICON_WEB).concat(gameListArray[0], ".png")
          };
        } else {
          return messageType.icon;
        }

      default:
        if (icon != null && icon !== '') {
          return utils.getPlatform() === PLATFORM.WEB ? "".concat(imagesCdnBaseUrl, "/inbox_messages/").concat(icon) : {
            uri: "".concat(imagesCdnBaseUrl, "/inbox_messages/").concat(icon)
          };
        } else {
          return messageType.icon != null ? messageType.icon : '';
        }

    }
  };

  var getActionHandler = function getActionHandler() {
    if (messageType.type === messageTypes.GAME) {
      dynamicActionHandler(action);
    } else if (messageType.type === messageTypes.OFFER && utils.getPlatform() !== 'web') {
      buyHandler(message);
    } else {
      collectRewardHandler(message, messageType.type);
    }
  };

  var collectRewardHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message, type) {
      var _QueryParamProxy$setQ2, productSku, payload, sneakPeekGameId, collectResponse, sneakPeakAction;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              audio.onClick();

              if (!(type === messageTypes.VIP_PASS && unlimitedVipAccess)) {
                _context.next = 4;
                break;
              }

              QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
              return _context.abrupt("return");

            case 4:
              if (!(type === messageTypes.OFFER)) {
                _context.next = 9;
                break;
              }

              productSku = message.cpil_id;
              QueryParamProxy.setQueryParams((_QueryParamProxy$setQ2 = {}, _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_MODAL, Screens.Shop), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_PURCHASE_SKU, productSku), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_PURCHASE_TYPE, PurchaseTypes.CURRENCY), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_PURCHASE_NAME, message.subject), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_OFFER_ENABLE, true), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_OFFER_DETAIL, {
                sku: productSku,
                name: message.subject,
                type: PurchaseTypes.CURRENCY,
                amount: message.coins,
                price: message.price,
                messageId: message.message_id,
                cpil_id: message.cpil_id
              }), _QueryParamProxy$setQ2));
              logger.setActionTrigger(purchaseActionTriggers.PERSONALIZED_OFFER_BUY_BUTTON);
              return _context.abrupt("return");

            case 9:
              _context.prev = 9;

              /** @type {CollectMessageRewardsResponse} */
              payload = {
                messageId: message.message_id
              };

              if (type === messageTypes.SNEAK_PEEK) {
                sneakPeekGameId = message.action && message.action.split(':')[1];
                payload.gameId = sneakPeekGameId;
              }

              _context.next = 14;
              return MessageInterface.collectMessageRewards(payload);

            case 14:
              collectResponse = _context.sent;

              if (!collectResponse.success) {
                _context.next = 34;
                break;
              }

              audio.playCoinSfx();
              _context.t0 = type;
              _context.next = _context.t0 === messageTypes.VIP_PASS ? 20 : _context.t0 === messageTypes.SNEAK_PEEK ? 25 : 28;
              break;

            case 20:
              fetchGameRooms(true);
              ShopInterface.refreshActiveConsumables();
              dispatch(setPurchaseType(rewardTypes.VIP_ROOM_ACCESS));
              dynamicActionHandler(message.action);
              return _context.abrupt("break", 31);

            case 25:
              sneakPeakAction = "sneakPeek:".concat(sneakPeekGameId, ",").concat(collectResponse.reward_info.sneakPeekEndDate);
              dynamicActionHandler(sneakPeakAction);
              return _context.abrupt("break", 31);

            case 28:
              collectResponse.reward_info = transformObjectArrayResponse(collectResponse.reward_info);
              context.addNotification({
                message: "".concat(getText(TEXT_KEY.REDEEM_MESSAGE_CONGRATS), " \r\n ").concat(collectResponse.reward_info.map(function (reward) {
                  return "".concat(reward.amount, " ").concat(reward.currency);
                }), " ").concat(getText(TEXT_KEY.REDEEM_MESSAGE_CONGRATS_TEXT)),
                title: getText(TEXT_KEY.REWARD_INFO),
                button: getText(TEXT_KEY.OK),
                hideHelpButton: true
              });
              return _context.abrupt("break", 31);

            case 31:
              InboxMessagesProvider.removeMessage(message.message_id, false);
              _context.next = 35;
              break;

            case 34:
              context.addNotification({
                message: collectResponse.error || getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
                title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                button: getText(TEXT_KEY.OK)
              });

            case 35:
              _context.next = 40;
              break;

            case 37:
              _context.prev = 37;
              _context.t1 = _context["catch"](9);
              context.addNotification({
                message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
                title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                button: getText(TEXT_KEY.OK)
              });

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 37]]);
    }));

    return function collectRewardHandler(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var dynamicActionHandler = function dynamicActionHandler(action) {
    audio.onClick();
    DynamicAction.getActionCallback(action, navigation)();
  };

  var deleteMessage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              audio.onClick();

              try {
                InboxMessagesProvider.removeMessage(id);
              } catch (e) {
                console.error(e);
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function deleteMessage(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    getMessageType: getMessageType,
    getBackgroundImage: getBackgroundImage,
    getSubtitle: getSubtitle,
    getIconImage: getIconImage,
    getActionHandler: getActionHandler,
    deleteMessage: deleteMessage
  };
};

export default useMessageItem;